"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zIndexDef = void 0;
exports.zIndexDef = {
    canvasRoot: 3,
    z1: 1,
    z2: 2
};
